import { motion, AnimatePresence } from "framer-motion";

const categories = [
  {
    id: "crypto",
    label: "Crypto",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M7.84474 12.7259C11.1274 13.3046 11.9381 8.70927 8.6554 8.12993M7.84474 12.7259L3.90674 12.0313M7.84474 12.7259L7.61407 14.0393M6.0294 7.66727L8.65607 8.12993C11.9387 8.70927 12.7494 4.11327 9.46607 3.5346L5.52674 2.83993M9.4654 3.5346L9.6974 2.22127M4.98674 13.5759L7.07074 1.75793"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    id: "politics",
    label: "Politics",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M6 7.99996L7.33333 9.33329L10 6.66663"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.33325 4.66671C3.33325 3.93337 3.93325 3.33337 4.66659 3.33337H11.3333C11.6869 3.33337 12.026 3.47385 12.2761 3.7239C12.5261 3.97395 12.6666 4.31309 12.6666 4.66671V12.6667H3.33325V4.66671Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.6666 12.6666H1.33325"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    id: "finance",
    label: "Finance",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M10.6667 4.66663H14.6667V8.66663"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.6666 4.66663L8.99992 10.3333L5.66659 6.99996L1.33325 11.3333"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    id: "sports",
    label: "Sports",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M6.66675 9.77332V10.8573C6.66423 11.0857 6.60307 11.3097 6.48914 11.5077C6.3752 11.7056 6.21231 11.871 6.01608 11.988C5.59951 12.2965 5.26064 12.698 5.0264 13.1604C4.79217 13.6229 4.66902 14.1336 4.66675 14.652"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.33325 9.77332V10.8573C9.33577 11.0857 9.39693 11.3097 9.51086 11.5077C9.6248 11.7056 9.78769 11.871 9.98392 11.988C10.4005 12.2965 10.7394 12.698 10.9736 13.1604C11.2078 13.6229 11.331 14.1336 11.3333 14.652"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 5.99996H13C13.442 5.99996 13.866 5.82436 14.1785 5.5118C14.4911 5.19924 14.6667 4.77532 14.6667 4.33329C14.6667 3.89127 14.4911 3.46734 14.1785 3.15478C13.866 2.84222 13.442 2.66663 13 2.66663H12"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.66675 14.6666H13.3334"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 6.00004C4 7.06091 4.42143 8.07832 5.17157 8.82847C5.92172 9.57861 6.93913 10 8 10C9.06087 10 10.0783 9.57861 10.8284 8.82847C11.5786 8.07832 12 7.06091 12 6.00004V2.00004C12 1.82323 11.9298 1.65366 11.8047 1.52864C11.6797 1.40361 11.5101 1.33337 11.3333 1.33337H4.66667C4.48986 1.33337 4.32029 1.40361 4.19526 1.52864C4.07024 1.65366 4 1.82323 4 2.00004V6.00004Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.99992 5.99996H2.99992C2.55789 5.99996 2.13397 5.82436 1.82141 5.5118C1.50885 5.19924 1.33325 4.77532 1.33325 4.33329C1.33325 3.89127 1.50885 3.46734 1.82141 3.15478C2.13397 2.84222 2.55789 2.66663 2.99992 2.66663H3.99992"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    id: "technology",
    label: "Tech",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M8 13.3334V14.6667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 1.33337V2.66671"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3333 13.3334V14.6667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3333 1.33337V2.66671"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.33325 8H2.66659"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.33325 11.3334H2.66659"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.33325 4.66663H2.66659"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.3333 8H14.6666"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.3333 11.3334H14.6666"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.3333 4.66663H14.6666"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.66675 13.3334V14.6667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.66675 1.33337V2.66671"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.0001 2.66663H4.00008C3.2637 2.66663 2.66675 3.26358 2.66675 3.99996V12C2.66675 12.7363 3.2637 13.3333 4.00008 13.3333H12.0001C12.7365 13.3333 13.3334 12.7363 13.3334 12V3.99996C13.3334 3.26358 12.7365 2.66663 12.0001 2.66663Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.99992 5.33337H5.99992C5.63173 5.33337 5.33325 5.63185 5.33325 6.00004V10C5.33325 10.3682 5.63173 10.6667 5.99992 10.6667H9.99992C10.3681 10.6667 10.6666 10.3682 10.6666 10V6.00004C10.6666 5.63185 10.3681 5.33337 9.99992 5.33337Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    id: "entertainment",
    label: "Culture",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.66675 2V14"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2 5H4.66667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2 8H14"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2 11H4.66667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3333 2V14"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3333 5H13.9999"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3333 11H13.9999"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    id: "science",
    label: "Science",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M9.33324 1.33337V5.33337C9.33314 5.55703 9.38931 5.77712 9.49657 5.97337L13.1699 12.6934C13.281 12.8964 13.3373 13.1249 13.3333 13.3564C13.3293 13.5878 13.2652 13.8143 13.1471 14.0134C13.0291 14.2125 12.8612 14.3774 12.66 14.492C12.4589 14.6065 12.2314 14.6668 11.9999 14.6667H3.9999C3.76842 14.6668 3.54091 14.6065 3.33976 14.492C3.13861 14.3774 2.97075 14.2125 2.8527 14.0134C2.73464 13.8143 2.67046 13.5878 2.66646 13.3564C2.66246 13.1249 2.71879 12.8964 2.8299 12.6934L6.50323 5.97337C6.6105 5.77712 6.66666 5.55703 6.66657 5.33337V1.33337"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.302 10H11.698"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.66675 1.33337H10.3334"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    id: "business",
    label: "Business",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M8 8H8.00667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.6666 4.00004V2.66671C10.6666 2.31309 10.5261 1.97395 10.2761 1.7239C10.026 1.47385 9.68687 1.33337 9.33325 1.33337H6.66659C6.31296 1.33337 5.97383 1.47385 5.72378 1.7239C5.47373 1.97395 5.33325 2.31309 5.33325 2.66671V4.00004"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.6666 8.66663C12.6884 9.97261 10.3703 10.6688 7.99992 10.6688C5.62955 10.6688 3.31139 9.97261 1.33325 8.66663"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.3333 4H2.66659C1.93021 4 1.33325 4.59695 1.33325 5.33333V12C1.33325 12.7364 1.93021 13.3333 2.66659 13.3333H13.3333C14.0696 13.3333 14.6666 12.7364 14.6666 12V5.33333C14.6666 4.59695 14.0696 4 13.3333 4Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    id: "gaming",
    label: "Gaming",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M4 7.33337H6.66667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.33325 6V8.66667"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 8H10.0067"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 6.66663H12.0067"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.5466 3.33337H4.45325C3.79344 3.33353 3.15711 3.57829 2.66727 4.02035C2.17744 4.46241 1.86888 5.07037 1.80125 5.72671C1.79725 5.76137 1.79459 5.79404 1.78992 5.82804C1.73592 6.27737 1.33325 9.63737 1.33325 10.6667C1.33325 11.1971 1.54397 11.7058 1.91904 12.0809C2.29411 12.456 2.80282 12.6667 3.33325 12.6667C3.99992 12.6667 4.33325 12.3334 4.66659 12L5.60925 11.0574C5.85924 10.8073 6.19833 10.6668 6.55192 10.6667H9.44792C9.80151 10.6668 10.1406 10.8073 10.3906 11.0574L11.3333 12C11.6666 12.3334 11.9999 12.6667 12.6666 12.6667C13.197 12.6667 13.7057 12.456 14.0808 12.0809C14.4559 11.7058 14.6666 11.1971 14.6666 10.6667C14.6666 9.63671 14.2639 6.27737 14.2099 5.82804C14.2053 5.79471 14.2026 5.76137 14.1986 5.72737C14.1311 5.07091 13.8226 4.46279 13.3328 4.0206C12.8429 3.5784 12.2065 3.33354 11.5466 3.33337Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    id: "other",
    label: "Other",
    svg: (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M7.99992 8.66671C8.36811 8.66671 8.66659 8.36823 8.66659 8.00004C8.66659 7.63185 8.36811 7.33337 7.99992 7.33337C7.63173 7.33337 7.33325 7.63185 7.33325 8.00004C7.33325 8.36823 7.63173 8.66671 7.99992 8.66671Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.6667 8.66671C13.0349 8.66671 13.3333 8.36823 13.3333 8.00004C13.3333 7.63185 13.0349 7.33337 12.6667 7.33337C12.2985 7.33337 12 7.63185 12 8.00004C12 8.36823 12.2985 8.66671 12.6667 8.66671Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.33341 8.66671C3.7016 8.66671 4.00008 8.36823 4.00008 8.00004C4.00008 7.63185 3.7016 7.33337 3.33341 7.33337C2.96522 7.33337 2.66675 7.63185 2.66675 8.00004C2.66675 8.36823 2.96522 8.66671 3.33341 8.66671Z"
            stroke="#DAD9D9"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </>
    ),
  },
];

export const SmartTopicChips = ({
  selectedCategories,
  highlightedCategories,
  onSelect,
  animateFromBottom = false,
  maxSelectable = 3,
}) => {
  const safeSelectedCategories = selectedCategories || [];
  const safeHighlightedCategories = highlightedCategories || [];
  const maxReached = safeSelectedCategories.length >= maxSelectable;

  const sortedCategories = [...categories].sort((a, b) => {
    const aHighlighted = safeHighlightedCategories.includes(a.id);
    const bHighlighted = safeHighlightedCategories.includes(b.id);
    const aSelected = safeSelectedCategories.includes(a.id);
    const bSelected = safeSelectedCategories.includes(b.id);

    if (aHighlighted && !bHighlighted) return -1;
    if (!aHighlighted && bHighlighted) return 1;
    if (aSelected && !bSelected) return -1;
    if (!aSelected && bSelected) return 1;
    return 0;
  });

  return (
    <div className="gm-topics-wrap">
      <AnimatePresence mode="popLayout">
        {sortedCategories.map((category, index) => {
          const isHighlighted = safeHighlightedCategories.includes(category.id);
          const isSelected = safeSelectedCategories.includes(category.id);
          const isRelevant = isHighlighted || isSelected;
          const isDisabled = maxReached && !isSelected;

          const relevantIndex = safeHighlightedCategories.indexOf(category.id);
          const isFirstBatch = relevantIndex !== -1;
          const animationDelay = animateFromBottom
            ? isFirstBatch
              ? relevantIndex * 0.3
              : safeHighlightedCategories.length * 0.3 + 0.8 + index * 0.05
            : index * 0.03;

          return (
            <motion.button
              key={category.id}
              layout
              initial={
                animateFromBottom
                  ? { opacity: 0, y: 80, scale: 0.6 }
                  : { opacity: 0, scale: 0.8 }
              }
              animate={{
                opacity: isDisabled ? 0.5 : 1,
                y: 0,
                scale: 1,
              }}
              exit={{ opacity: 0, scale: 0.8, y: -20 }}
              transition={{
                delay: animationDelay,
                type: "spring",
                stiffness: 200,
                damping: 20,
                layout: { duration: 0.4 },
              }}
              whileHover={isDisabled ? {} : { scale: 1.08, y: -3 }}
              whileTap={isDisabled ? {} : { scale: 0.95 }}
              onClick={() => !isDisabled && onSelect(category.id)}
              disabled={isDisabled}
              className={`gm-topic-chip ${
                isDisabled ? "gm-topic-chip--disabled" : ""
              } ${
                isSelected
                  ? "gm-topic-chip--selected"
                  : isHighlighted
                    ? "gm-topic-chip--highlighted"
                    : "gm-topic-chip--default"
              }`}
            >
              {isRelevant && (
                <motion.div
                  className="gm-topic-glow"
                  animate={{ opacity: [0.5, 1, 0.5] }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  style={{
                    background: isSelected
                      ? "hsl(var(--foreground) / 0.2)"
                      : "hsl(var(--primary) / 0.4)",
                    filter: "blur(8px)",
                  }}
                />
              )}

              <span className="gm-topic-label">{category.svg}{category.label}</span>
            </motion.button>
          );
        })}
      </AnimatePresence>
    </div>
  );
};
